const CSRF_TOKEN_STORAGE_KEY = "MFP-CSRF-TOKEN";
export const CSRF_HEADER_NAME = "X-CSRF-Token";

const isMutationMethod = (method = "get") => !["get", "head", "options"].includes(method.toLowerCase());

export const getStoredCsrfToken = () => {
    if (typeof window === "undefined") {
        return null;
    }

    try {
        return window.localStorage.getItem(CSRF_TOKEN_STORAGE_KEY);
    } catch {
        return null;
    }
};

export const storeCsrfToken = (token) => {
    if (typeof window === "undefined") {
        return;
    }

    try {
        if (token) {
            window.localStorage.setItem(CSRF_TOKEN_STORAGE_KEY, token);
            return;
        }

        window.localStorage.removeItem(CSRF_TOKEN_STORAGE_KEY);
    } catch {
        // Ignore storage failures so auth flows can continue.
    }
};

export const applyCsrfHeader = (config) => {
    if (!isMutationMethod(config?.method)) {
        return config;
    }

    const csrfToken = getStoredCsrfToken();

    if (!csrfToken) {
        return config;
    }

    config.headers = config.headers ?? {};
    config.headers[CSRF_HEADER_NAME] = csrfToken;
    return config;
};
